import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { RevenueGrowthSystemSection } from "@/components/sections/RevenueGrowthSystemSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const RevenueSystem = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Revenue System | It's All About Growth"
        description="How we connect GTM, acquisition, conversion, and retention into a single operating model that compounds revenue predictably."
        path="/revenue-system"
      />
      <Header />
      <main className="pt-20">
        <RevenueGrowthSystemSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default RevenueSystem;
